import { CommonModule, CurrencyPipe, DatePipe, TitleCasePipe, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output, ViewChild, ViewContainerRef } from '@angular/core';
import { Column, resolveTagSeverity } from 'src/app/ui/tables';
import { ContactCardUrlPipe } from '../../pipes/contact-card-url.pipe';
import { TagModule } from 'primeng/tag';
import { Table, TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { IconService } from '../../icon.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TruncatePipe } from "../../pipes/truncate.pipe";
import { TooltipModule } from 'primeng/tooltip';
import { SanitizeHtmlPipe } from '../../pipes/safe-html.pipe';
import { RootsUrlPipe } from '../../pipes/roots-url.pipe';
import { ExternalUrlPipe } from '../../pipes/external-url.pipe';

@Component({
  selector: 'app-table-columns',
  imports: [DatePipe, CurrencyPipe, DecimalPipe, ContactCardUrlPipe, TagModule, TitleCasePipe, TableModule, ButtonModule, CommonModule, FontAwesomeModule, TooltipModule, SanitizeHtmlPipe, RootsUrlPipe, ExternalUrlPipe],
  standalone: true,
  templateUrl: './table-columns.component.html',
  styleUrl: './table-columns.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableColumnsComponent {

  readonly resolveTagSeverity = resolveTagSeverity

  columns = input.required<Column<any>[]>()
  data = input.required<any>()
  
  // Outputs for action button clicks
  logActivityClick = output<any>()
  scheduleActivityClick = output<any>()

  //Output for cell click to filter another table
  filterTable = input<Table | null>(null);
  cellClick = output<{columnField: string, filterValue: any, columnIndex: number | undefined, targetTable: string | undefined, filterColumnFieldId: string | undefined}>();

  


  styles = computed(() => {
    return this.columns().reduce((acc, column) => {
      if (column.styleFunction) {
        acc[column.field] = column.styleFunction(this.data());
      } else if (column.type === 'boolean') {
        if (column.highlightTrue && this.data()[column.field]) {
          acc[column.field] = { 'color': 'var(--p-success-500)' };
        } else if (column.highlightFalse && !this.data()[column.field]) {
          acc[column.field] = { 'color': 'var(--p-danger-500)' };
        } else {
          acc[column.field] = {};
        }
      } else {
        acc[column.field] = {};
      }
      return acc;
    }, {} as Record<string, any>);
  })

  

  tooltipValues = computed(() => {
    return this.columns().reduce((acc, column) => {
      let tooltip = undefined
      if (column.includeTooltip) {

         tooltip = this.data()[column.field]

      
          if (typeof column.tooltipValue === 'string') {
            tooltip = column.tooltipValue;
          }
          else if (column.tooltipValue && typeof column.tooltipValue === 'object' && 'field' in column.tooltipValue) {
            tooltip = this.data()[column.tooltipValue.field];
          }
          else if (column.tooltipValue && typeof column.tooltipValue === 'function') {
            tooltip = column.tooltipValue(this.data());
          }
       

        acc[column.field] = tooltip;
      }
      return acc;
    }, {} as Record<string, any>);
  })

  onCellClick(column: Column<any>, value: any, event: Event) {  
    event.preventDefault();
    if (column.clickeable) {
      this.cellClick.emit({
        columnField: column.field,
        filterValue: value,
        columnIndex: column.filterColumnIndex,
        targetTable: column.filterTableRef,
        filterColumnFieldId: column.filterColumnField 
      });
    }
  }

  @ViewChild('template', { static: true }) template: any;

  // Handle log activity button click
  onLogActivityClick(data: any, event: Event) {
    event.stopPropagation();
    this.logActivityClick.emit(data);
  }

  // Handle schedule activity button click
  onScheduleActivityClick(data: any, event: Event) {
    event.stopPropagation();
    this.scheduleActivityClick.emit(data);
  }

  constructor(
    private viewContainerRef: ViewContainerRef,
    public icons: IconService
  ) { }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template)
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  formatPercentage(value: string | number | null | undefined): string {
    if (value === null || value === undefined) return '-';
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return '-';
    if (num >= 0 && num <= 1) {
      return (num * 100).toFixed(0) + '%';
    }
    return num.toFixed(0) + '%';
  }

  debugPhoneColumn(column: any, data: any): void {
    if (column.type === 'phone') {
      console.log('🔍 Phone column debug:', {
        field: column.field,
        type: column.type,
        value: data[column.field],
        hasValue: !!data[column.field]
      });
    }
  }

}
